import { render } from "./AddSubChannelDialog.vue?vue&type=template&id=5fa2c5da"
import script from "./AddSubChannelDialog.vue?vue&type=script&lang=js"
export * from "./AddSubChannelDialog.vue?vue&type=script&lang=js"

import "./AddSubChannelDialog.vue?vue&type=style&index=0&id=5fa2c5da&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__